import { IMembersState } from '~/store/organization/members/IMembersState'

export default (): IMembersState => ({
  members: {}
})
